(function () {
  "use strict";

  // Reads website cookie and pixel consent only; patient communications consent is managed separately.
  var STORAGE_KEY = "drsknn_attribution_v1";
  var COOKIE_KEY = "drsknn_attribution";
  var VISITOR_KEY = "drsknn_visitor_id";
  var SESSION_KEY = "drsknn_session_id";
  var SESSION_STARTED_KEY = "drsknn_session_started_at";
  var ATTR_KEYS = [
    "gclid",
    "gbraid",
    "wbraid",
    "oppref",
    "ttclid",
    "msclkid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "fbclid",
    "fbp",
    "fbc",
    "campaign",
    "asset_variant",
    "funnel_stage",
    "landing_source",
    "origin_role",
    "conversion_event"
  ];
  var TIKTOK_COMPETING_CLICK_KEYS = [
    "gclid", "gbraid", "wbraid", "oppref", "fbclid", "fbp", "fbc", "msclkid"
  ];
  var ACQUISITION_CLICK_KEYS = [
    "gclid", "gbraid", "wbraid", "oppref", "ttclid", "msclkid", "fbclid", "fbp", "fbc"
  ];
  var ORIGIN_STALE_CONTEXT_KEYS = [
    "qr_source", "qr_scan_id", "offer_id", "offer_name", "offer_area", "treatment_area",
    "provider_role", "discount_percent", "offer_valid_from", "offer_valid_until",
    "booking_payment_amount", "booking_payment_amount_pence", "booking_payment_label",
    "booking_payment_policy", "booking_refund_policy", "selected_areas", "selected_service_ids",
    "employee_ids"
  ];
  var TARGET_HOSTS = [
    "drsknn.uk",
    "www.drsknn.uk",
    "drsknn-explorer-rs8d.onrender.com",
    "drsknn-explorer-rs8d-rs8d.onrender.com",
    "partner.pabau.com",
    "connect.pabau.com",
    "skinxs.com",
    "www.skinxs.com"
  ];
  var BOOKING_CONSULTATION_URL = "https://www.drsknn.uk/kiosk?tab=treatments";
  var LEGACY_BOOKING_RE = /(connect-uk1\.pabau\.me\/bookings\.php|connect\.pabau\.com\/bookings\.php|partner\.pabau\.com\/online-bookings|www\.drsknn\.com\/kiosk\?(consultations|treatments)|drsknn\.uk\/kiosk\?treatments)/i;
  var LEGACY_BOOKING_URL_RE = /https?:\/\/(?:connect-uk1\.pabau\.me\/bookings\.php|connect\.pabau\.com\/bookings\.php|partner\.pabau\.com\/online-bookings\/drsknn)[^'"\s<)]*|https?:\/\/(?:www\.)?drsknn\.com\/kiosk\?(?:consultations|treatments)|https?:\/\/(?:www\.)?drsknn\.uk\/kiosk\?treatments/gi;
  var FAMILY_ALIASES = [
    ["hydrafacial", ["hydrafacial", "hydra facial"]],
    ["injectables", ["botox", "injectable", "anti wrinkle", "anti-wrinkle", "filler", "profhilo", "polynucleotide"]],
    ["skin_boosters", ["skin booster", "skinboosters", "seventy hyal", "sunekos"]],
    ["acne", ["acne", "blemish", "breakout"]],
    ["pigmentation", ["pigmentation", "melasma", "dark spot", "hyperpigmentation"]],
    ["laser", ["laser", "ipl", "resurfacing"]],
    ["consultation", ["consultation", "consult", "skin scan", "appointment"]],
    ["skincare", ["skincare", "cream", "cleanser", "serum", "universkin"]]
  ];

  var state = {
    maxScroll: 0,
    clickCount: 0,
    startedAt: Date.now(),
    engagementSent: false,
    lastPageKey: "",
    lastActionKey: "",
    lastActionAt: 0,
    scrollMilestones: {},
    viewedSections: {},
    clickBurst: [],
    sectionObserver: null,
    tiktokLoaded: false
  };

  function currentScript() {
    return document.currentScript || (function () {
      var scripts = document.getElementsByTagName("script");
      return scripts[scripts.length - 1] || null;
    })();
  }

  var script = currentScript();
  var dataset = script && script.dataset ? script.dataset : {};
  var config = {
    eventUrl: dataset.drsknnEventUrl || window.DRSKNN_BROWSER_EVENT_URL || "",
    publicToken: dataset.drsknnPublicToken || window.DRSKNN_BROWSER_EVENT_TOKEN || "",
    sourceProperty: dataset.drsknnSourceProperty || window.location.hostname,
    googleEvents: dataset.drsknnGoogleEvents !== "false",
    metaEvents: dataset.drsknnMetaEvents !== "false",
    tiktokEvents: dataset.drsknnTiktokEvents !== "false",
    tiktokPixelCode: clean(dataset.drsknnTiktokPixelCode || "D9NQ2FJC77U6HL2V6TF0", 80),
    adIntentDetail: dataset.drsknnAdIntentDetail === "true",
    cartAttributes: dataset.drsknnCartAttributes !== "false"
  };

  function isObject(value) {
    return value && typeof value === "object" && !Array.isArray(value);
  }

  function clean(value, maxLen) {
    if (value == null) return "";
    var text = String(value).replace(/[\r\n\t]/g, " ").replace(/\s+/g, " ").trim();
    if (!text) return "";
    return text.slice(0, maxLen || 255);
  }

  function readCookie(name) {
    try {
      var prefix = encodeURIComponent(name) + "=";
      var parts = document.cookie ? document.cookie.split(";") : [];
      for (var i = 0; i < parts.length; i += 1) {
        var part = parts[i].trim();
        if (part.indexOf(prefix) === 0) {
          return decodeURIComponent(part.slice(prefix.length));
        }
      }
    } catch (e) {}
    return "";
  }

  function writeCookie(name, value, maxAgeSeconds) {
    try {
      var secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value)
        + "; Max-Age=" + (maxAgeSeconds || 60 * 60 * 24 * 90)
        + "; Path=/; SameSite=Lax" + secure;
    } catch (e) {}
  }

  function randomId(prefix) {
    var raw = "";
    try {
      var arr = new Uint8Array(16);
      window.crypto.getRandomValues(arr);
      raw = Array.prototype.map.call(arr, function (n) {
        return ("0" + n.toString(16)).slice(-2);
      }).join("");
    } catch (e) {
      raw = String(Date.now()) + String(Math.random()).slice(2);
    }
    return prefix + "_" + raw;
  }

  function readStoredJson(storageKey, cookieKey) {
    try {
      var raw = window.localStorage && window.localStorage.getItem(storageKey);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (isObject(parsed)) return parsed;
      }
    } catch (e) {}
    try {
      var cookie = readCookie(cookieKey);
      if (cookie) {
        var cookieParsed = JSON.parse(cookie);
        if (isObject(cookieParsed)) return cookieParsed;
      }
    } catch (e) {}
    return {};
  }

  function writeStoredJson(storageKey, cookieKey, data) {
    var payload = JSON.stringify(data);
    try {
      if (window.localStorage) window.localStorage.setItem(storageKey, payload);
    } catch (e) {}
    writeCookie(cookieKey, payload, 60 * 60 * 24 * 90);
  }

  function readStored() {
    var record = readStoredJson(STORAGE_KEY, COOKIE_KEY);
    var captured = Date.parse(record.captured_at || "");
    var age = Date.now() - captured;
    // The cookie already expires after 90 days; localStorage must obey the same bound.
    if (!isFinite(captured) || age < -300000 || age > 90 * 86400000) return {};
    return record;
  }

  function googleMeasurementContext() {
    if (!analyticsAllowed()) return {};
    var api = window.DRSKNN_GOOGLE_MEASUREMENT;
    return api && typeof api.getIdentity === "function" ? api.getIdentity() : {};
  }

  function writeStored(data) {
    writeStoredJson(STORAGE_KEY, COOKIE_KEY, data);
  }

  function stableId(key, prefix, maxAgeSeconds) {
    if (window.DRSKNN_PRIVACY_MODE === "iubenda" && !analyticsAllowed()) return prefix + "_pending";
    var existing = "";
    try {
      existing = window.localStorage && window.localStorage.getItem(key);
    } catch (e) {}
    existing = existing || readCookie(key);
    if (existing) return existing;
    var created = randomId(prefix);
    try {
      if (window.localStorage) window.localStorage.setItem(key, created);
    } catch (e) {}
    writeCookie(key, created, maxAgeSeconds);
    return created;
  }

  function visitorId() {
    return stableId(VISITOR_KEY, "v", 60 * 60 * 24 * 365);
  }

  function sessionId() {
    if (window.DRSKNN_PRIVACY_MODE === "iubenda" && !analyticsAllowed()) return "s_pending";
    var now = Date.now();
    var started = 0;
    try {
      started = Number(window.sessionStorage && window.sessionStorage.getItem(SESSION_STARTED_KEY));
    } catch (e) {}
    if (!started || now - started > 30 * 60 * 1000) {
      try {
        if (window.sessionStorage) {
          window.sessionStorage.setItem(SESSION_KEY, randomId("s"));
          window.sessionStorage.setItem(SESSION_STARTED_KEY, String(now));
        }
      } catch (e) {}
    }
    try {
      return (window.sessionStorage && window.sessionStorage.getItem(SESSION_KEY)) || stableId(SESSION_KEY, "s", 60 * 60);
    } catch (e) {
      return stableId(SESSION_KEY, "s", 60 * 60);
    }
  }

  function incomingParams() {
    var params = new URLSearchParams(window.location.search || "");
    var out = {};
    ATTR_KEYS.forEach(function (key) {
      var value = clean(params.get(key), 255);
      if (value) out[key] = value;
    });
    return out;
  }

  function isIncomingTikTok(params) {
    params = params || {};
    return Boolean(params.ttclid || String(params.utm_source || "").toLowerCase() === "tiktok");
  }

  function startsNewAcquisition(incoming) {
    incoming = incoming || {};
    var hasClickId = ACQUISITION_CLICK_KEYS.some(function (key) {
      return Boolean(incoming[key]);
    });
    var hasExplicitCampaign = Boolean(
      incoming.utm_source
      && (incoming.utm_medium || incoming.utm_campaign || incoming.campaign)
    );
    return hasClickId || hasExplicitCampaign;
  }

  function isolateTikTokStoredAttribution(record, incoming) {
    if (!isIncomingTikTok(incoming)) return;
    TIKTOK_COMPETING_CLICK_KEYS.forEach(function (key) {
      delete record[key];
    });
    if (!incoming.utm_term) delete record.utm_term;
  }

  function isolateTikTokUrl(url, incoming) {
    if (!isIncomingTikTok(incoming)) return;
    var current = new URLSearchParams(window.location.search || "");
    var isOriginHandoff = window.location.pathname.replace(/\/$/, "") === "/origin-laser" &&
      /\/kiosk\/origin\/consultation\/(doctor|nurse|practitioner)(?:\/|$)/.test(url.pathname);

    TIKTOK_COMPETING_CLICK_KEYS.forEach(function (key) {
      url.searchParams.delete(key);
    });
    ["ttclid", "utm_content", "utm_term", "asset_variant", "funnel_stage"].forEach(function (key) {
      var value = current.get(key);
      if (value) url.searchParams.set(key, value);
      else url.searchParams.delete(key);
    });
    url.searchParams.set("utm_source", "tiktok");
    url.searchParams.set("utm_medium", current.get("utm_medium") || "paid_social");
    var campaign = current.get("utm_campaign") || current.get("campaign");
    if (campaign) {
      url.searchParams.set("utm_campaign", campaign);
      url.searchParams.set("campaign", campaign);
    }

    if (!isOriginHandoff) return;
    ORIGIN_STALE_CONTEXT_KEYS.forEach(function (key) {
      var value = current.get(key);
      if (value) url.searchParams.set(key, value);
      else url.searchParams.delete(key);
    });
    url.searchParams.set("landing_source", current.get("landing_source") || "origin_page");
    url.searchParams.set("conversion_event", current.get("conversion_event") || "completed_booking");
    var roleMatch = url.pathname.match(/\/consultation\/(doctor|nurse|practitioner)(?:\/|$)/);
    url.searchParams.set("origin_role", roleMatch ? roleMatch[1] : (current.get("origin_role") || "doctor"));
  }

  function captureAttribution() {
    if (!marketingAllowed()) return readStored();
    var existing = readStored();
    var incoming = incomingParams();
    var hasIncoming = Object.keys(incoming).length > 0;
    var replaceExisting = startsNewAcquisition(incoming);
    var merged = {};

    if (!replaceExisting) {
      Object.keys(existing).forEach(function (key) {
        if (ATTR_KEYS.indexOf(key) !== -1 || key === "captured_at" || key === "landing_url") {
          merged[key] = existing[key];
        }
      });
    }
    isolateTikTokStoredAttribution(merged, incoming);

    if (hasIncoming) {
      ATTR_KEYS.forEach(function (key) {
        if (incoming[key] && (replaceExisting || !merged[key])) {
          merged[key] = incoming[key];
        }
      });
      merged.captured_at = new Date().toISOString();
      merged.landing_url = clean(window.location.href, 2000);
      writeStored(merged);
    }

    return merged;
  }

  function consentState() {
    var stateOut = {
      analytics_storage: "unknown",
      marketing_storage: "unknown",
      ad_personalization: "unknown"
    };
    try {
      if (window.DRSKNN_CONSENT_STATE) {
        return {
          analytics_storage: window.DRSKNN_CONSENT_STATE.analytics ? "granted" : "denied",
          marketing_storage: window.DRSKNN_CONSENT_STATE.marketing ? "granted" : "denied",
          ad_personalization: window.DRSKNN_CONSENT_STATE.marketing ? "granted" : "denied"
        };
      }
      if (window.DRSKNN_PRIVACY_MODE === "iubenda") {
        if (!window._iub || !_iub.cs || !_iub.cs.api || typeof _iub.cs.api.getPreferences !== "function") {
          return { analytics_storage: "denied", marketing_storage: "denied", ad_personalization: "denied" };
        }
        var prefs = _iub.cs.api.getPreferences();
        var purposes = prefs && prefs.purposes ? prefs.purposes : {};
        var analytics = purposes["4"] === true || purposes[4] === true;
        var marketing = purposes["5"] === true || purposes[5] === true;
        return {
          analytics_storage: analytics ? "granted" : "denied",
          marketing_storage: marketing ? "granted" : "denied",
          ad_personalization: marketing ? "granted" : "denied"
        };
      }
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        var privacy = window.Shopify.customerPrivacy;
        if (typeof privacy.analyticsProcessingAllowed === "function") {
          stateOut.analytics_storage = privacy.analyticsProcessingAllowed() ? "granted" : "denied";
        }
        if (typeof privacy.marketingAllowed === "function") {
          stateOut.marketing_storage = privacy.marketingAllowed() ? "granted" : "denied";
          stateOut.ad_personalization = privacy.marketingAllowed() ? "granted" : "denied";
        }
      }
    } catch (e) {}
    return stateOut;
  }

  function analyticsAllowed() {
    var consent = consentState();
    return consent.analytics_storage === "granted";
  }

  function marketingAllowed() {
    var consent = consentState();
    return consent.marketing_storage === "granted";
  }

  function explicitMarketingAllowed() {
    return consentState().marketing_storage === "granted";
  }

  function intentFromText(text, path) {
    var haystack = clean([text, path || window.location.pathname].join(" "), 1000).toLowerCase();
    for (var i = 0; i < FAMILY_ALIASES.length; i += 1) {
      var family = FAMILY_ALIASES[i][0];
      var aliases = FAMILY_ALIASES[i][1];
      for (var j = 0; j < aliases.length; j += 1) {
        if (haystack.indexOf(aliases[j]) !== -1) {
          return { family: family, label: aliases[j], score: 0.7 };
        }
      }
    }
    return {};
  }

  function pageEventType(intent) {
    var path = window.location.pathname.toLowerCase();
    if (path.indexOf("/products/") !== -1) return "product_view";
    if (path.indexOf("/collections/") !== -1) return "service_view";
    if (intent.family && intent.family !== "skincare") return "viewed_treatment";
    return "page_view";
  }

  function pageKey() {
    return [window.location.pathname, window.location.search, window.location.hash, clean(document.title, 120)].join("|");
  }

  function datasetText(element) {
    var output = [];
    try {
      if (!element || !element.dataset) return "";
      Object.keys(element.dataset).forEach(function (key) {
        var lower = key.toLowerCase();
        if (/(email|phone|name|address|postcode|zip|token|secret|password)/.test(lower)) return;
        output.push(key + ":" + clean(element.dataset[key], 120));
      });
    } catch (e) {}
    return output.join(" ");
  }

  function safeFieldName(element) {
    return clean(
      (element && element.getAttribute && (
        element.getAttribute("name")
        || element.getAttribute("id")
        || element.getAttribute("aria-label")
        || element.getAttribute("placeholder")
      )) || "",
      120
    );
  }

  function isSafeIntentField(element) {
    var text = safeFieldName(element).toLowerCase();
    if (!text || /(email|phone|mobile|name|address|postcode|zip|dob|date of birth|password|card)/.test(text)) return false;
    return /(search|query|filter|treatment|service|concern|condition|category|slot|time|date|practitioner|clinic)/.test(text);
  }

  function fieldKind(element) {
    var text = safeFieldName(element).toLowerCase();
    var type = clean(element && element.getAttribute ? element.getAttribute("type") : "", 40).toLowerCase();
    if (/(email|phone|mobile|name|address|postcode|zip|dob|date of birth)/.test(text) || ["email", "tel"].indexOf(type) !== -1) {
      return "contact_details_field";
    }
    if (/(card|payment|cvc|cvv|expiry|password|secret|token)/.test(text) || type === "password") {
      return "payment_or_secret_field";
    }
    if (/(search|query|filter)/.test(text)) return "search_or_filter_field";
    if (/(treatment|service|concern|condition|category)/.test(text)) return "treatment_preference_field";
    if (/(slot|time|date|practitioner|clinic)/.test(text)) return "booking_preference_field";
    return "form_field";
  }

  function elementLabel(element) {
    if (!element || !element.getAttribute) return "";
    var labelledBy = clean(element.getAttribute("aria-labelledby"), 120);
    var labelledText = "";
    try {
      if (labelledBy) {
        labelledText = labelledBy.split(/\s+/).map(function (id) {
          var labelled = document.getElementById(id);
          return labelled ? clean(labelled.textContent, 120) : "";
        }).filter(Boolean).join(" ");
      }
    } catch (e) {}
    return clean(
      element.getAttribute("aria-label")
        || element.getAttribute("title")
        || element.getAttribute("data-treatment-name")
        || element.getAttribute("data-treatment")
        || element.getAttribute("data-service")
        || element.getAttribute("data-practitioner")
        || element.getAttribute("data-practitioner-name")
        || element.getAttribute("data-concern")
        || element.getAttribute("data-condition")
        || labelledText
        || datasetText(element)
        || element.textContent
        || element.value
        || "",
      220
    );
  }

  function classifyInteraction(combined, url, host) {
    var text = clean(combined, 700);
    var protocol = url && url.protocol ? url.protocol.toLowerCase() : "";
    if (protocol === "tel:") return "click_to_call";
    if (protocol === "mailto:") return "email_click";
    if (/^(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)$/i.test(host) || /whats\s*app/i.test(text)) return "whatsapp_click";
    if (/live[ -]?chat|chat with|start chat|message us/i.test(text)) return "chat_started";
    var isBooking = ["drsknn.uk", "www.drsknn.uk", "partner.pabau.com", "connect.pabau.com"].indexOf(host) !== -1
      || /book|appointment|consult|checkout|pay|stripe|continue|confirm/i.test(text);
    var isTimeslot = /timeslot|time-slot|booking-slot|slot|appointment time|select time|\b\d{1,2}:\d{2}\b/i.test(text);
    var isPractitioner = /practitioner|clinician|doctor|nurse|therapist|provider|team member|consultant|dr\b/i.test(text);
    var isReview = /review|testimonial|rating|stars|trustpilot|google review|before and after|result|case study/i.test(text);
    var looksTreatment = /treatment|service|concern|condition|consultation|hydrafacial|botox|filler|laser|acne|pigment|skin booster|peel|universkin/i.test(text);
    if (isTimeslot) return "selected_timeslot";
    if (isPractitioner) return "practitioner_selected";
    if (isReview) return "review_engagement";
    if (isBooking && /next|continue|confirm|payment|checkout|pay|back|step|slot|time|date/i.test(text)) return "booking_step";
    if (isBooking) return "booking_link_click";
    if (url && host && host !== window.location.hostname.toLowerCase()) return "outbound_link_click";
    if (looksTreatment) return "viewed_treatment";
    return "click";
  }

  function isShopifyStorefrontHost(host) {
    return [
      "drsknn.com",
      "www.drsknn.com",
      "drsknn.store",
      "www.drsknn.store",
      "drsknn.online",
      "www.drsknn.online"
    ].indexOf((host || "").toLowerCase()) !== -1;
  }

  function shouldDecorate(url) {
    var host = (url.hostname || "").toLowerCase();
    return TARGET_HOSTS.some(function (allowed) {
      return host === allowed;
    });
  }

  function decorateUrl(rawUrl) {
    if (!rawUrl || rawUrl.indexOf("mailto:") === 0 || rawUrl.indexOf("tel:") === 0 || rawUrl.indexOf("#") === 0) {
      return rawUrl;
    }
    var url;
    try {
      url = new URL(rawUrl, window.location.href);
    } catch (e) {
      return rawUrl;
    }
    if (!shouldDecorate(url)) return rawUrl;

    var allowMarketing = marketingAllowed();
    var data = allowMarketing ? readStored() : {};
    var incoming = incomingParams();
    ATTR_KEYS.forEach(function (key) {
      var value = data[key] || incoming[key];
      if (value && !url.searchParams.get(key)) {
        url.searchParams.set(key, value);
      }
    });
    isolateTikTokUrl(url, incoming);
    if (allowMarketing) {
      url.searchParams.set("drsknn_visitor_id", visitorId());
      url.searchParams.set("drsknn_session_id", sessionId());
      url.searchParams.set("attribution_source", "drsknn_owned_site");
    } else if (Object.keys(incoming).length) {
      url.searchParams.set("attribution_source", "drsknn_owned_site");
    }
    // This context belongs only to the owned booking app, never third-party link targets.
    if (url.protocol === "https:" && ["drsknn.uk", "www.drsknn.uk"].indexOf(url.hostname) !== -1) {
      var measurement = googleMeasurementContext();
      ["ga_client_id", "ga_session_id", "ga_measurement_id", "ga_identity_captured_at"].forEach(function (key) {
        if (measurement[key]) url.searchParams.set(key, measurement[key]);
        else url.searchParams.delete(key);
      });
    }
    return url.toString();
  }

  function isLegacyBookingTarget(value) {
    return Boolean(value && LEGACY_BOOKING_RE.test(String(value)));
  }

  function normalizeBookingText(value) {
    if (!value || !isLegacyBookingTarget(value)) return value;
    return String(value).replace(LEGACY_BOOKING_URL_RE, BOOKING_CONSULTATION_URL);
  }

  function normalizeBookingElement(element) {
    if (!element || !element.getAttribute || element.hasAttribute("data-drsknn-booking-normalized")) return false;
    var changed = false;
    ["href", "data-href", "data-url"].forEach(function (attr) {
      var value = element.getAttribute(attr);
      if (isLegacyBookingTarget(value)) {
        element.setAttribute(attr, BOOKING_CONSULTATION_URL);
        changed = true;
      }
    });
    var onclick = element.getAttribute("onclick");
    var normalizedOnclick = normalizeBookingText(onclick);
    if (normalizedOnclick && normalizedOnclick !== onclick) {
      element.setAttribute("onclick", normalizedOnclick);
      changed = true;
    }
    if (changed) element.setAttribute("data-drsknn-booking-normalized", "true");
    return changed;
  }

  function normalizeBookingLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    try {
      if (scope.matches && (scope.matches("a[href], [onclick], [data-href], [data-url]"))) {
        normalizeBookingElement(scope);
      }
      scope.querySelectorAll("a[href], [onclick], [data-href], [data-url]").forEach(normalizeBookingElement);
    } catch (e) {}
  }

  function handleLegacyBookingClick(event, element) {
    try {
      if (!element || !element.getAttribute) return false;
      var target = [
        element.getAttribute("href"),
        element.getAttribute("data-href"),
        element.getAttribute("data-url"),
        element.getAttribute("onclick")
      ].join(" ");
      if (!isLegacyBookingTarget(target) && !(target.indexOf(BOOKING_CONSULTATION_URL) !== -1 && /openPabauModal/i.test(target))) {
        return false;
      }
      normalizeBookingElement(element);
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      window.location.href = BOOKING_CONSULTATION_URL;
      return true;
    } catch (e) {}
    return false;
  }

  function decorateElement(element, attr) {
    try {
      if (!element || element.hasAttribute("data-drsknn-no-attribution")) return;
      var original = element.getAttribute(attr);
      var decorated = decorateUrl(original);
      if (decorated && decorated !== original) element.setAttribute(attr, decorated);
    } catch (e) {}
  }

  function decorateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    try {
      normalizeBookingLinks(scope);
      scope.querySelectorAll("a[href]").forEach(function (link) {
        decorateElement(link, "href");
      });
      scope.querySelectorAll("iframe[src]").forEach(function (frame) {
        decorateElement(frame, "src");
      });
    } catch (e) {}
  }

  function publicEventUrl() {
    if (!config.eventUrl) return "";
    if (!config.publicToken) return "";
    try {
      var url = new URL(config.eventUrl, window.location.href);
      url.search = "";
      url.hash = "";
      return url.toString();
    } catch (e) {
      return config.eventUrl.split(/[?#]/, 1)[0];
    }
  }

  function buildPayload(eventType, extra) {
    extra = extra || {};
    var attribution = readStored();
    var intent = extra.intent || intentFromText(document.title, window.location.pathname);
    return {
      event_type: eventType,
      occurred_at: new Date().toISOString(),
      external_event_id: randomId("evt"),
      source_property: config.sourceProperty,
      page_url: clean(window.location.href, 1024),
      page_title: clean(document.title, 255),
      page_path: clean(window.location.pathname, 512),
      referrer: clean(document.referrer, 1024),
      anonymous_id: visitorId(),
      session_id: sessionId(),
      attribution: attribution,
      consent: consentState(),
      intent: intent,
      element: extra.element || {},
      engagement: extra.engagement || {},
      ecommerce: extra.ecommerce || productContext(),
      meta: {
        fbp: clean(readCookie("_fbp"), 255),
        fbc: clean(readCookie("_fbc"), 255)
      },
      context: {
        measurement_context: googleMeasurementContext(),
        user_agent_family: "browser",
        user_agent: clean(window.navigator && window.navigator.userAgent, 512),
        viewport_width: window.innerWidth || 0,
        viewport_height: window.innerHeight || 0,
        source_script: "drsknn-browser-intent-v2"
      }
    };
  }

  // BEGIN GENERATED PRIVATE BROWSER OUTBOX
  /* No historical import or new advertising destination; existing endpoint behavior is preserved. */
  function createDrSknnPrivateBrowserOutbox(win, options) {
    "use strict";
    var DB = "drsknn_private_browser_outbox_v1", SIGNAL = DB + "_consent";
    var TTL = 3600000, MAX_COUNT = 64, MAX_BYTES = 262144, MAX_BODY = 8192;
    var BACKOFF = [2000, 5000, 15000, 60000, 180000, 600000, 900000];
    var LEASE = 20000, REQUEST_TIMEOUT = 10000, MAX_RESPONSE = 16384;
    // A bounded private-record retry assertion, never authentication or delivery proof.
    var DEFER_MIN_REMAINING = 1020000;
    var dbPromise, timer, busy = false, active = new Set(), closed = false, deniedByPeer = false, nextWake = null, wakeAgain = false;
    var endpoint, channel, encoder;
    try { encoder = new win.TextEncoder(); } catch (_) { return { enqueue: function () { return Promise.resolve(false); }, close: function () {} }; }
    try {
      endpoint = new win.URL(options.url);
      if (endpoint.protocol !== "https:" || endpoint.hostname !== "drsknn-marketing.onrender.com" ||
          endpoint.port || endpoint.username || endpoint.password || endpoint.search || endpoint.hash ||
          ["/ingest/browser/events", "/api/meta/event"].indexOf(endpoint.pathname) < 0 ||
          !options.token || !win.AbortController) throw new Error("unavailable");
    } catch (_) { return { enqueue: function () { return Promise.resolve(false); }, close: function () {} }; }

    function now() { return Date.now(); }
    function size(value) { return encoder.encode(value).byteLength; }
    function permission() {
      try {
        var p = options.consent();
        return { analytics: p.analytics_storage === "granted", marketing: p.marketing_storage === "granted",
          known: ["granted", "denied"].indexOf(p.analytics_storage) >= 0 &&
            ["granted", "denied"].indexOf(p.marketing_storage) >= 0 };
      } catch (_) { return { analytics: false, marketing: false, known: false }; }
    }
    function open() {
      if (!dbPromise) dbPromise = new Promise(function (resolve, reject) {
        var req = win.indexedDB.open(DB, 1), finished = false;
        var timeout = win.setTimeout(function () { finished = true; reject(new Error("storage_unavailable")); }, 3000);
        req.onupgradeneeded = function () {
          req.result.createObjectStore("events", { keyPath: "id" });
          req.result.createObjectStore("control");
        };
        req.onsuccess = function () {
          win.clearTimeout(timeout);
          if (finished) { req.result.close(); return; }
          var db = req.result;
          db.onversionchange = function () { db.close(); closed = true; abort(); };
          resolve(db);
        };
        req.onerror = req.onblocked = function () { win.clearTimeout(timeout); finished = true; reject(new Error("storage_unavailable")); };
      });
      return dbPromise;
    }
    // Every read/modify/write operation shares one IndexedDB transaction across tabs.
    function transaction(fn) {
      return open().then(function (db) {
        return new Promise(function (resolve, reject) {
          var tx = db.transaction(["events", "control"], "readwrite", { durability: "strict" }), result;
          var events = tx.objectStore("events"), control = tx.objectStore("control");
          var er = events.getAll(undefined, MAX_COUNT + 1), cr = control.get(0), loaded = 0;
          tx.oncomplete = function () { resolve(result); };
          tx.onerror = tx.onabort = function () { reject(new Error("storage_unavailable")); };
          function finish() {
            if (++loaded !== 2) return;
            var strict = false;
            try { strict = tx.durability === "strict"; } catch (_) {}
            try { result = fn(events, control, er.result, cr.result, strict); }
            catch (_) { tx.abort(); }
          }
          er.onsuccess = cr.onsuccess = finish;
        });
      });
    }
    function abort() { active.forEach(function (controller) { controller.abort(); }); }
    function notify() {
      try { if (channel) channel.postMessage("revoked"); } catch (_) {}
      try { win.localStorage.setItem(SIGNAL, String(now()) + ":" + Math.random()); } catch (_) {}
    }
    function revokeFromPeer() { deniedByPeer = true; abort(); wake(); }
    function queued() {
      try { if (channel) channel.postMessage("queued"); } catch (_) {}
      try { win.localStorage.setItem(SIGNAL + "_wake", String(now()) + ":" + Math.random()); } catch (_) {}
    }
    try { channel = new win.BroadcastChannel(DB); channel.onmessage = function (event) {
      if (event.data === "revoked") revokeFromPeer(); else if (event.data === "queued") wake();
    }; } catch (_) {}
    win.addEventListener("storage", function (event) {
      if (event.key === SIGNAL) revokeFromPeer(); else if (event.key === SIGNAL + "_wake") wake();
    });
    function syncConsent() {
      var p = permission();
      if (!p.known) { abort(); return Promise.resolve(false); }
      if (!p.analytics || !p.marketing) abort();
      return transaction(function (events, control, rows, state) {
        state = state || { generation: 0, analytics: false, marketing: false };
        var revoked = (state.analytics && !p.analytics) || (state.marketing && !p.marketing);
        if (revoked || !p.analytics) {
          events.clear(); state.generation += 1; delete state.lease; notify();
        }
        state.analytics = p.analytics; state.marketing = p.marketing;
        control.put(state, 0);
        deniedByPeer = false;
        return p.analytics;
      }).catch(function () { return false; });
    }
    function validBody(body, id) {
      if (typeof body !== "string" || size(body) > MAX_BODY) return false;
      try {
        var p = JSON.parse(body);
        return p && typeof p === "object" && !Array.isArray(p) && p.external_event_id === id &&
          typeof id === "string" && /^[A-Za-z0-9_.:-]{1,120}$/.test(id) &&
          typeof p.event_type === "string" && /^[a-z][a-z0-9_]{0,99}$/.test(p.event_type) &&
          p.source_property === options.sourceProperty && p.consent && p.consent.analytics_storage === "granted" &&
          Number.isFinite(Date.parse(p.occurred_at));
      } catch (_) { return false; }
    }
    function rowsFor(events, rows, state) {
      if (rows.length > MAX_COUNT) { events.clear(); return []; }
      var total = 0;
      return rows.filter(function (row) {
        var valid = state && row && row.generation === state.generation && row.url === endpoint.href &&
          Number.isFinite(row.created) && row.created <= now() + 300000 && now() - row.created < TTL &&
          Number.isInteger(row.attempts) && row.attempts >= 0 && row.attempts <= 8 &&
          Number.isFinite(row.next) && validBody(row.body, row.id) &&
          row.bytes === size(row.body) && typeof row.marketing === "boolean" &&
          state.analytics && (!row.marketing || state.marketing);
        if (!valid || (total += row.bytes) > MAX_BYTES) { events.delete(row.id); return false; }
        return true;
      });
    }
    // Durable records contain only the receiver's useful, minimized browser facts.
    // Raw URL queries, text/labels, arbitrary context and ephemeral CAPI cookies never enter IndexedDB.
    function project(payload) {
      function string(value, limit) { return typeof value === "string" && value.length <= limit ? value : ""; }
      function path(value) { return value.split("/").map(function (segment) { return segment.split(";", 1)[0]; }).join("/"); }
      function url(value) {
        if (!value) return "";
        try { var u = new win.URL(value, win.location.href);
          return ["https:", "http:"].indexOf(u.protocol) >= 0 && !u.username && !u.password ? (u.origin + path(u.pathname)).slice(0, 1024) : "";
        } catch (_) { return ""; }
      }
      function number(value) { return typeof value === "number" && Number.isFinite(value) && Math.abs(value) <= 1000000000; }
      function present(value) { return value !== undefined && value !== null && value !== ""; }
      var p = permission(), out = {
        event_type: payload.event_type, external_event_id: payload.external_event_id, occurred_at: payload.occurred_at,
        source_property: payload.source_property, consent: {
          analytics_storage: "granted", marketing_storage: p.marketing ? "granted" : "denied",
          ad_personalization: p.marketing ? "granted" : "denied"
        }, attribution: {}, intent: {}, element: {}, engagement: {}, ecommerce: {}, context: {}, meta: {}
      };
      ["anonymous_id", "session_id"].forEach(function (key) {
        var value = string(payload[key], 120);
        if (/^[vs]_[A-Za-z0-9_.:-]{8,116}$/.test(value)) out[key] = value;
      });
      if (!out.anonymous_id && !out.session_id) return null;
      out.page_url = url(payload.page_url); out.referrer = url(payload.referrer);
      if (typeof payload.page_path === "string" && /^\//.test(payload.page_path)) out.page_path = path(payload.page_path.split(/[?#]/, 1)[0]).slice(0, 512);
      if (present(payload.page_title)) out.page_title = "present";
      var intent = payload.intent || {}, element = payload.element || {}, commerce = payload.ecommerce || {};
      var families = ["hydrafacial", "injectables", "skin_boosters", "acne", "pigmentation", "laser", "consultation", "skincare"];
      if (families.indexOf(intent.family) >= 0) out.intent.family = intent.family;
      if (number(intent.score)) out.intent.score = intent.score;
      if (present(intent.label)) out.intent.label = "present";
      if (present(element.label)) out.element.label = "present";
      if (/^[a-z_]{1,30}$/.test(element.role || "")) out.element.role = element.role;
      if (element.href) out.element.href = url(element.href);
      if (present(commerce.product_title)) out.ecommerce.product_title = "present";
      ["product_id", "variant_id"].forEach(function (key) {
        if (/^[0-9]{1,30}$/.test(String(commerce[key] || ""))) out.ecommerce[key] = String(commerce[key]);
      });
      ["value", "quantity", "price"].forEach(function (key) { if (number(commerce[key])) out.ecommerce[key] = commerce[key]; });
      if (/^[A-Z]{3}$/.test(commerce.currency || "")) out.ecommerce.currency = commerce.currency;
      var engagement = payload.engagement || {};
      ["duration_ms", "seconds_on_page", "duration_seconds", "max_scroll_percent", "scroll_percent", "click_count", "click_x", "click_y",
        "click_count_window", "window_ms", "visible_ratio"].forEach(function (key) {
        if (number(engagement[key])) out.engagement[key] = engagement[key];
      });
      if (typeof engagement.final === "boolean") out.engagement.final = engagement.final;
      if (["section_visible", "field_focus"].indexOf(engagement.action) >= 0) out.engagement.action = engagement.action;
      var context = payload.context || {};
      ["viewport_width", "viewport_height"].forEach(function (key) { if (number(context[key])) out.context[key] = context[key]; });
      if (context.source_script === "drsknn-browser-intent-v2") out.context.source_script = context.source_script;
      if (context.user_agent_family === "browser") out.context.user_agent_family = "browser";
      var identity = context.measurement_context;
      if (identity && identity.analytics_consent === true && identity.ga_measurement_id === "G-FC6YQ8SVMM" &&
          /^[0-9]{1,20}\.[0-9]{1,20}$/.test(identity.ga_client_id || "") &&
          /^[1-9][0-9]{0,12}$/.test(String(identity.ga_session_id || "")) &&
          typeof identity.ga_identity_captured_at === "string" && identity.ga_identity_captured_at.length <= 40 &&
          Number.isFinite(Date.parse(identity.ga_identity_captured_at))) {
        out.context.measurement_context = { analytics_consent: true, ad_user_data: identity.ad_user_data === true && p.marketing,
          ga_measurement_id: "G-FC6YQ8SVMM", ga_client_id: identity.ga_client_id,
          ga_session_id: String(identity.ga_session_id), ga_identity_captured_at: identity.ga_identity_captured_at };
      }
      function hasSearch(value, depth) {
        if (!value || typeof value !== "object" || depth > 6) return false;
        return Object.keys(value).slice(0, 100).some(function (key) {
          var name = key.toLowerCase().replace(/[^a-z0-9]+/g, "_");
          return (["keyword", "keywords", "q", "query", "query_text", "queries", "raw_query", "raw_query_text", "raw_search_text",
            "search_query", "search_queries", "search_term", "search_terms", "search_text", "term", "terms"].indexOf(name) >= 0 && present(value[key])) ||
            hasSearch(value[key], depth + 1);
        });
      }
      if ([payload.intent, payload.element, payload.engagement, payload.ecommerce, payload.context, payload.meta].some(function (value) {
        return hasSearch(value, 0);
      })) out.context.search_query = "present";
      var pageQuery;
      try { pageQuery = new win.URL(payload.page_url).searchParams; } catch (_) {}
      // These are existing receiver attribution fields, retained only with advertising consent.
      if (p.marketing) ["gclid", "gbraid", "wbraid", "oppref", "ttclid", "msclkid", "utm_source", "utm_medium", "utm_campaign",
        "utm_content", "utm_term", "fbclid", "qr_source", "qr_scan_id", "qr_session_id", "qr_publication", "qr_issue", "qr_page",
        "qr_creative", "qr_placement", "qr_product_slug"].forEach(function (key) {
          var value = string((payload.attribution || {})[key], 255) || string(pageQuery && pageQuery.get(key), 255);
          if (value && !/[\r\n@?#&=]/.test(value)) out.attribution[key] = value;
        });
      return out;
    }

    function enqueue(payload, immediate) {
      var p = permission(), body, original, initialRow = null, early = null;
      if (closed || deniedByPeer || !p.known || !p.analytics) return Promise.resolve(false);
      try { original = JSON.stringify(payload); body = original; } catch (_) { return Promise.resolve(false); }
      if (!validBody(body, payload.external_event_id) || payload.consent.marketing_storage !== (p.marketing ? "granted" : "denied") || Math.abs(now() - Date.parse(payload.occurred_at)) > 300000)
        return Promise.resolve(false);
      var projected = project(payload);
      if (!projected) { if (immediate) startImmediate(original); else bestEffort(original, false); return Promise.resolve(false); }
      body = JSON.stringify(projected);
      if (!validBody(body, payload.external_event_id)) { if (immediate) startImmediate(original); else bestEffort(original, false); return Promise.resolve(false); }
      // A departing document may never finish an IndexedDB callback. Preserve the
      // existing synchronous keepalive attempt; persistence remains best effort here.
      if (immediate) early = startImmediate(original);
      return initialized.then(function () {
        return transaction(function (events, control, rows, state) {
          var current = permission();
          if (closed || deniedByPeer || !current.known || !current.analytics || !state || !state.analytics ||
              p.marketing !== current.marketing || (p.marketing && !state.marketing)) return false;
          rows = rowsFor(events, rows, state);
          var existing = rows.find(function (r) { return r.id === payload.external_event_id; });
          if (existing) return existing.body === body;
          if (rows.length >= MAX_COUNT || rows.reduce(function (sum, r) { return sum + r.bytes; }, 0) + size(body) > MAX_BYTES) return false;
          // This atomic per-record reservation preserves immediate first-capture dispatch.
          // Other tabs see only minimized data and cannot retry while its initial lease is live.
          initialRow = { id: payload.external_event_id, body: body, bytes: size(body), created: now(),
            generation: state.generation, marketing: p.marketing, attempts: 1, next: now() + LEASE,
            token: String(now()) + ":" + Math.random(), initial: true,
            url: endpoint.href, immediate: Boolean(immediate) };
          events.add(initialRow);
          return true;
        });
      }).then(function (saved) {
        if (saved) {
          if (initialRow) {
            var delivery = early ? early.result.then(function (terminal) { return settle(initialRow, terminal); }) : send(initialRow, original);
            delivery.catch(function () {}).finally(function () { queued(); wake(); });
          }
          queued(); wake();
        }
        return saved;
      }).catch(function () {
        // Storage did not acknowledge this new capture. A single bounded attempt retains
        // the old best-effort capability, never pretending persistence or importing history.
        if (!early) bestEffort(original, immediate); return false;
      });
    }
    function startImmediate(body) {
      var p = permission(), payload;
      try { payload = JSON.parse(body); } catch (_) { return null; }
      if (closed || active.size >= MAX_COUNT || deniedByPeer || !p.known || !p.analytics ||
          payload.consent.marketing_storage !== (p.marketing ? "granted" : "denied")) return null;
      var controller = new win.AbortController(); active.add(controller);
      var timeout = win.setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT), result;
      try {
        result = win.fetch(endpoint.href, { method: "POST", mode: "cors", credentials: "omit", redirect: "error",
          referrerPolicy: "no-referrer", keepalive: true,
          headers: { "Content-Type": "text/plain", "X-DrSknn-Browser-Token": options.token },
          body: body, signal: controller.signal });
      } catch (_) { result = Promise.reject(new Error("delivery_uncertain")); }
      return { result: Promise.resolve(result).then(function (response) {
        if ([400, 401, 403, 404, 409, 410, 413, 422].indexOf(response.status) >= 0) return true;
        return receipt(response, { body: body });
      }).catch(function () { return false; }).finally(function () {
        win.clearTimeout(timeout); active.delete(controller);
      }) };
    }
    function bestEffort(body, immediate) {
      var p = permission(), payload;
      try { payload = JSON.parse(body); } catch (_) { return; }
      if (closed || active.size || deniedByPeer || !p.known || !p.analytics ||
          !validBody(body, payload.external_event_id) ||
          payload.consent.marketing_storage !== (p.marketing ? "granted" : "denied") ||
          Math.abs(now() - Date.parse(payload.occurred_at)) > 300000) return;
      var controller = new win.AbortController(); active.add(controller);
      var timeout = win.setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT);
      Promise.resolve().then(function () {
        var latest = permission();
        if (controller.signal.aborted || !latest.known || !latest.analytics || deniedByPeer ||
            payload.consent.marketing_storage !== (latest.marketing ? "granted" : "denied")) return;
        return win.fetch(endpoint.href, { method: "POST", mode: "cors", credentials: "omit", redirect: "error",
          referrerPolicy: "no-referrer", keepalive: Boolean(immediate),
          headers: { "Content-Type": "text/plain", "X-DrSknn-Browser-Token": options.token },
          body: body, signal: controller.signal });
      }).catch(function () {}).finally(function () {
        win.clearTimeout(timeout); active.delete(controller);
      });
    }
    function claim() {
      return transaction(function (events, control, rows, state) {
        var p = permission();
        rows = rowsFor(events, rows, state);
        nextWake = rows.length ? Math.min.apply(null, rows.map(function (r) {
          return Math.min(r.created + TTL, r.attempts < 8 ? Math.max(r.next, now()) : r.created + TTL);
        })) : null;
        if (state && state.lease && state.lease.until > now() && nextWake !== null) nextWake = Math.max(nextWake, state.lease.until);
        if (closed || deniedByPeer || !p.known || !p.analytics || !state || !state.analytics) { nextWake = null; return null; }
        if (state.lease && state.lease.until > now()) return null;
        if (!rows.some(function (r) { return !r.marketing || p.marketing; })) { nextWake = null; return null; }
        rows.sort(function (a, b) { return a.created - b.created; });
        var row = rows.find(function (r) { return r.attempts < 8 && r.next <= now() && (!r.marketing || p.marketing); });
        if (!row) return null;
        var token = String(now()) + ":" + Math.random();
        nextWake = now() + 1000;
        row.initial = false; row.attempts += 1; row.token = token; row.next = now() + (BACKOFF[row.attempts - 1] || TTL);
        state.lease = { token: token, until: now() + LEASE };
        events.put(row); control.put(state, 0);
        return row;
      });
    }
    function stillAllowed(row, original) {
      return transaction(function (events, control, rows, state, strict) {
        var p = permission(), current = rows.find(function (r) { return r.id === row.id; });
        var allowed = !closed && !deniedByPeer && p.known && p.analytics && (!row.marketing || p.marketing) &&
          state && state.analytics && state.generation === row.generation &&
          current && current.token === row.token &&
          (row.initial ? current.initial === true && current.next > now() :
            state.lease && state.lease.token === row.token && state.lease.until > now());
        return { allowed: allowed, defer: Boolean(allowed && strict && !row.immediate &&
          current.body === row.body && current.created === row.created && current.attempts === row.attempts &&
          validBody(row.body, row.id) && (!row.initial || initialPrivateParity(original, row.body))) };
      });
    }
    // Conservative equivalence of the current receiver's private reporting fields.
    // Raw redaction diagnostics and volatile CAPI fields are deliberately not compared.
    // Initial deferral is admitted server-side only while the pinned CAPI boundaries deny.
    function initialPrivateParity(original, stored) {
      function object(value) { return value && typeof value === "object" && !Array.isArray(value); }
      function keys(value, allowed) { return object(value) && Object.keys(value).every(function (key) { return allowed.indexOf(key) >= 0; }); }
      function equal(a, b) {
        if (typeof a !== typeof b) return false;
        if (typeof a === "number") return Number.isFinite(a) && a === b;
        if (!object(a) || !object(b)) return a === b;
        var ak = Object.keys(a).sort(), bk = Object.keys(b).sort();
        return ak.length === bk.length && ak.every(function (key, i) { return key === bk[i] && equal(a[key], b[key]); });
      }
      function presence(value) {
        if (value === undefined || value === null || value === "") return false;
        if (typeof value !== "string" || !value.trim()) throw new Error("unknown_presence");
        return true;
      }
      function text(value) {
        if (value === undefined || value === null || value === "") return "";
        if (typeof value !== "string") throw new Error("unknown_text");
        return value;
      }
      function url(value, page) {
        value = text(value); if (!value) return "";
        // No attribution-query interpretation, URL parser coercion or truncation proof.
        if (value.length > 1024 || !/^[\x21-\x7e]+$/.test(value) || /\\/.test(value) ||
            !/^https?:\/\/[a-z0-9.-]+(?::[0-9]+)?\//.test(value) || (page && value.indexOf("?") >= 0))
          throw new Error("unknown_url");
        return value.split(/[?#]/, 1)[0].split("/").map(function (part) { return part.split(";", 1)[0]; }).join("/");
      }
      function group(value, allowed, label) {
        value = value === undefined || value === null ? {} : value;
        if (!keys(value, allowed)) throw new Error("unknown_fields");
        var result = Object.assign({}, value);
        if (label) { result[label] = presence(value[label]); }
        return result;
      }
      function signature(payload) {
        if (!keys(payload, ["event_type", "external_event_id", "occurred_at", "source_property", "anonymous_id", "session_id",
            "consent", "attribution", "intent", "element", "engagement", "ecommerce", "context", "meta",
            "page_url", "page_title", "page_path", "referrer"])) throw new Error("unknown_payload");
        var result = {};
        ["event_type", "external_event_id", "occurred_at", "source_property", "anonymous_id", "session_id"].forEach(function (key) {
          result[key] = text(payload[key]);
        });
        result.page_url = url(payload.page_url, true); result.referrer = url(payload.referrer, false);
        result.page_title = presence(payload.page_title);
        var path = text(payload.page_path);
        if (path && (!/^\/[\x21-\x7e]*$/.test(path) || path.length > 512 || /\\/.test(path))) throw new Error("unknown_path");
        result.page_path = path.split(/[?#]/, 1)[0].split("/").map(function (part) { return part.split(";", 1)[0]; }).join("/");
        result.consent = group(payload.consent, ["analytics_storage", "marketing_storage", "ad_personalization"]);
        result.attribution = group(payload.attribution, ["gclid", "gbraid", "wbraid", "oppref", "ttclid", "msclkid", "utm_source",
          "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "qr_source", "qr_scan_id", "qr_session_id",
          "qr_publication", "qr_issue", "qr_page", "qr_creative", "qr_placement", "qr_product_slug", "captured_at", "landing_url"]);
        // This bounded capture metadata is unused by the receiver's private record.
        // Ignore it only in the comparison; first-send and durable bodies stay unchanged.
        if (result.attribution.landing_url !== undefined) {
          if (typeof result.attribution.landing_url !== "string" || result.attribution.landing_url.length > 2000)
            throw new Error("unknown_attribution_metadata");
          delete result.attribution.landing_url;
        }
        if (result.attribution.captured_at !== undefined) {
          if (typeof result.attribution.captured_at !== "string" || result.attribution.captured_at.length > 40 ||
              !Number.isFinite(Date.parse(result.attribution.captured_at))) throw new Error("unknown_attribution_metadata");
          delete result.attribution.captured_at;
        }
        result.intent = group(payload.intent, ["family", "label", "score"], "label");
        result.element = group(payload.element, ["role", "label", "href"], "label");
        result.element.href = url(result.element.href, false);
        result.ecommerce = group(payload.ecommerce, ["product_id", "variant_id", "product_title", "value", "quantity", "price", "currency"], "product_title");
        result.engagement = group(payload.engagement, ["duration_ms", "seconds_on_page", "duration_seconds", "max_scroll_percent", "scroll_percent",
          "click_count", "click_x", "click_y", "click_count_window", "window_ms", "visible_ratio", "final", "action"]);
        result.context = group(payload.context, ["viewport_width", "viewport_height", "source_script", "user_agent_family", "user_agent", "measurement_context"]);
        if (result.context.user_agent !== undefined) {
          if (typeof result.context.user_agent !== "string" || result.context.user_agent.length > 512) throw new Error("unknown_agent");
          delete result.context.user_agent;
        }
        // The receiver represents absent, null and an empty JSON identity identically.
        // Preserve all nonempty values: even rejected identities can carry search markers.
        var measurement = result.context.measurement_context;
        if (measurement === null || (measurement && typeof measurement === "object" &&
            !Array.isArray(measurement) && Object.keys(measurement).length === 0)) {
          delete result.context.measurement_context;
        }
        result.meta = group(payload.meta, ["fbp", "fbc", "_fbp", "_fbc"]);
        Object.keys(result.meta).forEach(function (key) {
          if (typeof result.meta[key] !== "string" || result.meta[key].length > 255) throw new Error("unknown_capi");
          delete result.meta[key];
        });
        return result;
      }
      try { return equal(signature(JSON.parse(original)), signature(JSON.parse(stored))); }
      catch (_) { return false; }
    }
    function deferralHeader(row, proof) {
      var remaining = Math.floor(TTL - (now() - row.created));
      if (!proof || !proof.defer || !Number.isInteger(row.attempts) || row.attempts < 1 || row.attempts > 7 ||
          !Number.isFinite(remaining) || remaining < DEFER_MIN_REMAINING || remaining > TTL) return null;
      return "idb-private-v1;a=" + row.attempts + ";r=" + remaining;
    }
    function settle(row, terminal) {
      return transaction(function (events, control, rows, state) {
        if (!state || state.generation !== row.generation) return;
        var current = rows.find(function (r) { return r.id === row.id; });
        if (current && current.token === row.token) {
          if (terminal || current.attempts >= 8) events.delete(row.id);
          else if (current.initial) {
            current.initial = false; current.next = now() + BACKOFF[0]; events.put(current);
          }
        }
        if (state.lease && state.lease.token === row.token) { delete state.lease; control.put(state, 0); }
      });
    }
    function receipt(response, row) {
      if (response.status !== 200 || response.redirected || !response.body || !response.body.getReader)
        return Promise.resolve(false);
      var reader = response.body.getReader(), chunks = [], length = 0;
      function read() {
        return reader.read().then(function (part) {
          if (part.done) {
            var bytes = new Uint8Array(length), offset = 0;
            chunks.forEach(function (x) { bytes.set(x, offset); offset += x.byteLength; });
            var data = JSON.parse(new win.TextDecoder("utf-8", { fatal: true }).decode(bytes));
            var item = data && data.results && data.results[0], payload = JSON.parse(row.body);
            return data.status === "accepted" && data.accepted === 1 && Array.isArray(data.results) &&
              data.results.length === 1 && item && item.event_type === payload.event_type &&
              ((typeof item.event_id === "string" && /^[A-Za-z0-9_-]{1,128}$/.test(item.event_id)) ||
                (Number.isSafeInteger(item.event_id) && item.event_id > 0));
          }
          length += part.value.byteLength;
          if (length > MAX_RESPONSE) { reader.cancel(); return false; }
          chunks.push(part.value); return read();
        });
      }
      return read().catch(function () { return false; });
    }
    function send(row, original) {
      var controller = new win.AbortController(), timeout;
      active.add(controller);
      return stillAllowed(row, original).then(function (proof) {
        if (!proof.allowed) return false;
        timeout = win.setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT);
        var headers = { "Content-Type": "text/plain", "X-DrSknn-Browser-Token": options.token };
        var capability = deferralHeader(row, proof);
        if (capability) headers["X-DrSknn-Outbox"] = capability;
        return win.fetch(endpoint.href, { method: "POST", mode: "cors", credentials: "omit", redirect: "error",
          referrerPolicy: "no-referrer", keepalive: row.immediate,
          headers: headers,
          body: row.initial && original ? original : row.body, signal: controller.signal }).then(function (response) {
            if ([400, 401, 403, 404, 409, 410, 413, 422].indexOf(response.status) >= 0) return true;
            return receipt(response, row);
          });
      }).catch(function () { return false; }).then(function (terminal) { return settle(row, terminal); })
        .finally(function () { win.clearTimeout(timeout); active.delete(controller); });
    }
    function wake() {
      if (closed) return;
      if (busy) { wakeAgain = true; return; }
      win.clearTimeout(timer);
      timer = win.setTimeout(pump, 0);
    }
    function pump() {
      if (closed || busy) return;
      busy = true;
      initialized.then(claim).then(function (row) { if (row) return send(row); }).catch(function () {})
        .finally(function () {
          busy = false;
          if (wakeAgain) { wakeAgain = false; wake(); }
          else if (!closed && nextWake !== null) timer = win.setTimeout(pump, Math.max(50, Math.min(60000, nextWake - now())));
        });
    }
    var initialized = syncConsent();
    initialized.then(wake);
    win.addEventListener("drsknn:consent-ready", function () { syncConsent().then(wake); });
    win.addEventListener("visitorConsentCollected", function () { syncConsent().then(wake); });
    win.addEventListener("online", wake);
    win.addEventListener("pageshow", wake);
    win.addEventListener("pagehide", wake);
    return { enqueue: enqueue, close: function () {
      closed = true; abort(); win.clearTimeout(timer); if (channel) channel.close();
      if (dbPromise) dbPromise.then(function (db) { db.close(); }).catch(function () {});
    } };
  }
  // END GENERATED PRIVATE BROWSER OUTBOX

  var privateBrowserJournal;
  function privateBrowserOutbox() {
    if (!privateBrowserJournal) privateBrowserJournal = createDrSknnPrivateBrowserOutbox(window, {
      url: publicEventUrl(), token: config.publicToken, sourceProperty: config.sourceProperty,
      consent: consentState
    });
    return privateBrowserJournal;
  }
  function sendToMarketingApp(payload, immediate) {
    if (!config.eventUrl || !config.publicToken || !analyticsAllowed()) return;
    privateBrowserOutbox().enqueue(payload, immediate);
  }

  function productContext() {
    var title = "";
    try {
      var heading = document.querySelector("h1, [data-product-title], .product__title");
      title = heading ? heading.textContent : "";
    } catch (e) {}
    return {
      product_title: clean(title, 255)
    };
  }

  function routeGroup(path) {
    path = clean(path || window.location.pathname, 255).toLowerCase();
    if (path === "/" || path === "") return "home";
    if (path.indexOf("/products/") === 0) return "product";
    if (path.indexOf("/collections/") === 0) return "collection";
    if (path.indexOf("/cart") === 0) return "cart";
    if (path.indexOf("/search") === 0) return "search";
    if (path.indexOf("/account") === 0) return "account";
    if (path.indexOf("/checkout") === 0) return "checkout";
    if (path.indexOf("/pages/") === 0) return "content";
    return "site";
  }

  function conservativeMetaEventName(eventType) {
    eventType = clean(eventType, 80).toLowerCase();
    if (eventType === "page_view") return "PageView";
    if (eventType === "product_view" || eventType === "service_view" || eventType === "section_view" || eventType === "viewed_treatment" || eventType === "viewed_practitioner" || eventType === "review_engagement") return "ViewContent";
    if (eventType === "search") return "Search";
    if (eventType === "add_to_cart") return "AddToCart";
    if (eventType === "checkout" || eventType === "checkout_handoff") return "InitiateCheckout";
    if (eventType === "purchase") return "Purchase";
    if (eventType === "started_booking" || eventType === "booking_link_click" || eventType === "booking_step" || eventType === "selected_timeslot") return "Schedule";
    if (eventType === "lead" || eventType === "form_submit") return "Lead";
    return "DrSknnIntent";
  }

  function safeGa4EventName(eventType) {
    eventType = clean(eventType, 80).toLowerCase();
    if (eventType === "purchase") return "purchase";
    // A DOM submit or contact click is intent; only authenticated success owns generate_lead.
    if (eventType === "form_submit") return "form_submit_attempt";
    if (eventType === "lead") return "lead_intent";
    if (["click_to_call", "email_click", "whatsapp_click", "chat_started"].indexOf(eventType) !== -1) return eventType;
    if (eventType === "checkout" || eventType === "checkout_handoff") return "begin_checkout";
    if (eventType === "add_to_cart") return "add_to_cart";
    if (eventType === "product_view" || eventType === "service_view" || eventType === "viewed_treatment") return "view_item";
    if (eventType === "started_booking" || eventType === "booking_link_click") return "booking_started";
    if (eventType === "booking_step") return "booking_step";
    if (eventType === "selected_timeslot") return "selected_timeslot";
    if (eventType === "price_list_viewed") return "price_list_viewed";
    if (eventType === "pricing_option_selected") return "pricing_option_selected";
    if (eventType === "service_family_viewed") return "service_family_viewed";
    if (eventType === "offer_viewed") return "offer_viewed";
    if (eventType === "offer_selected") return "offer_selected";
    if (eventType === "package_selected") return "package_selected";
    if (eventType === "subscription_interest") return "subscription_interest";
    return "";
  }

  function ga4EventParams(payload) {
    var params = {
      send_to: "G-FC6YQ8SVMM",
      event_id: clean(payload.external_event_id, 120),
      page_path: clean(payload.page_path, 255),
      page_group: routeGroup(payload.page_path),
      source_property: clean(payload.source_property, 255)
    };
    if (payload.ecommerce && typeof payload.ecommerce.value === "number") params.value = payload.ecommerce.value;
    if (payload.ecommerce && payload.ecommerce.currency) params.currency = clean(payload.ecommerce.currency, 16);
    return params;
  }

  function platformTagsAvailable() {
    return Array.isArray(window.dataLayer) || typeof window.gtag === "function";
  }

  function ensureTikTokPixel() {
    if (!config.tiktokEvents || !config.tiktokPixelCode || !explicitMarketingAllowed()) return false;
    if (state.tiktokLoaded && window.ttq) return true;
    try {
      (function (w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = w[t] = w[t] || [];
        ttq.methods = [
          "page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group",
          "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"
        ];
        ttq.setAndDefer = function (queue, method) {
          queue[method] = function () {
            queue.push([method].concat(Array.prototype.slice.call(arguments, 0)));
          };
        };
        for (var i = 0; i < ttq.methods.length; i += 1) ttq.setAndDefer(ttq, ttq.methods[i]);
        ttq.instance = function (pixelCode) {
          var instance = ttq._i[pixelCode] || [];
          for (var j = 0; j < ttq.methods.length; j += 1) ttq.setAndDefer(instance, ttq.methods[j]);
          return instance;
        };
        ttq.load = function (pixelCode, options) {
          var source = "https://analytics.tiktok.com/i18n/pixel/events.js";
          ttq._i = ttq._i || {};
          ttq._i[pixelCode] = [];
          ttq._i[pixelCode]._u = source;
          ttq._t = ttq._t || {};
          ttq._t[pixelCode] = +new Date();
          ttq._o = ttq._o || {};
          ttq._o[pixelCode] = options || {};
          var scriptTag = d.createElement("script");
          scriptTag.type = "text/javascript";
          scriptTag.async = true;
          scriptTag.src = source + "?sdkid=" + encodeURIComponent(pixelCode) + "&lib=" + encodeURIComponent(t);
          var firstScript = d.getElementsByTagName("script")[0];
          firstScript.parentNode.insertBefore(scriptTag, firstScript);
        };
      })(window, document, "ttq");
      window.ttq.load(config.tiktokPixelCode);
      window.ttq.page();
      state.tiktokLoaded = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function safeTikTokEventName(eventType) {
    eventType = clean(eventType, 80).toLowerCase();
    if (eventType === "page_view" || eventType === "landing_page_view" || eventType === "origin_page_view" || eventType === "product_view" || eventType === "service_view" || eventType === "service_family_viewed" || eventType === "viewed_treatment" || eventType === "viewed_condition" || eventType === "viewed_practitioner" || eventType === "price_list_viewed" || eventType === "offer_viewed") return "ViewContent";
    if (eventType === "click_to_call" || eventType === "whatsapp_click" || eventType === "email_click" || eventType === "chat_started") return "Contact";
    if (eventType === "generate_lead" || eventType === "submitted_lead" || eventType === "qualified_lead") return "SubmitForm";
    if (eventType === "completed_booking") return "Schedule";
    if (eventType === "purchase" || eventType === "paid_booking") return "Purchase";
    return "";
  }

  function tiktokEventProperties(payload, eventName) {
    var properties = {};
    if (eventName === "Purchase" && payload.ecommerce) {
      if (typeof payload.ecommerce.value === "number") properties.value = payload.ecommerce.value;
      if (payload.ecommerce.currency) properties.currency = clean(payload.ecommerce.currency, 8).toUpperCase();
    }
    return properties;
  }

  function emitPlatformEvent(payload) {
    var safe = {
      event_category: "drsknn_owned_site",
      event_name: conservativeMetaEventName(payload.event_type),
      interaction_type: clean(conservativeMetaEventName(payload.event_type).toLowerCase(), 80),
      page_group: routeGroup(payload.page_path),
      source_property: clean(payload.source_property, 255)
    };
    if (analyticsAllowed() && config.googleEvents && platformTagsAvailable()) {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: "drsknn_intent" }, safe));
      }
      if (typeof window.gtag === "function") {
        var ga4Name = safeGa4EventName(payload.event_type);
        if (ga4Name) window.gtag("event", ga4Name, ga4EventParams(payload));
        if (config.adIntentDetail) window.gtag("event", "drsknn_intent", safe);
      }
    }
    if (!marketingAllowed()) return;
    if (config.metaEvents && typeof window.fbq === "function") {
      window.fbq("trackCustom", "DrSknnIntent", safe, { eventID: payload.external_event_id });
    }
    var tiktokEventName = safeTikTokEventName(payload.event_type);
    if (tiktokEventName && ensureTikTokPixel() && window.ttq && typeof window.ttq.track === "function") {
      window.ttq.track(
        tiktokEventName,
        tiktokEventProperties(payload, tiktokEventName),
        { event_id: payload.external_event_id }
      );
    }
  }

  function track(eventType, extra, immediate) {
    if (!analyticsAllowed() && !marketingAllowed()) return;
    var payload = buildPayload(eventType, extra || {});
    sendToMarketingApp(payload, immediate);
    emitPlatformEvent(payload);
  }

  function trackOnce(eventType, extra, immediate) {
    var label = extra && extra.element ? extra.element.label || "" : "";
    var key = eventType + "|" + clean(label, 120) + "|" + window.location.href;
    if (eventType === "scroll_milestone" && extra && extra.engagement &&
        [25, 50, 75, 90].indexOf(extra.engagement.scroll_percent) !== -1) {
      key += "|" + extra.engagement.scroll_percent;
    }
    var now = Date.now();
    if (state.lastActionKey === key && now - state.lastActionAt < 750) return;
    state.lastActionKey = key;
    state.lastActionAt = now;
    track(eventType, extra, immediate);
  }

  function trackVirtualPage(reason) {
    var key = pageKey();
    if (key === state.lastPageKey) return;
    state.lastPageKey = key;
    decorateAll(document);
    var intent = intentFromText(document.title, window.location.pathname + " " + window.location.search + " " + window.location.hash);
    track(pageEventType(intent), {
      intent: intent,
      element: { role: "virtual_page", label: clean(reason || "route_change", 80) }
    });
    captureSearchFromUrl();
  }

  function importantElement(target) {
    if (!target || !target.closest) return null;
    return target.closest([
      "a[href]",
      "button",
      "[role='button']",
      "input[type='submit']",
      "[onclick]",
      "[data-action]",
      "[data-tab]",
      "[data-tab-target]",
      "[data-treatment]",
      "[data-treatment-id]",
      "[data-treatment-name]",
      "[data-service]",
      "[data-service-id]",
      "[data-category]",
      "[data-concern]",
      "[data-condition]",
      "[data-slot]",
      "[data-timeslot]",
      "[data-time-slot]",
      ".kiosk-card",
      ".treatment-card",
      ".service-card",
      ".consultation-card",
      ".slot",
      ".time-slot",
      ".booking-slot",
      ".tab",
      ".pill",
      ".chip"
    ].join(", "));
  }

  function clickPayload(element) {
    var href = element && element.getAttribute ? element.getAttribute("href") : "";
    var url = null;
    try {
      url = href ? new URL(href, window.location.href) : null;
    } catch (e) {}
    var label = elementLabel(element);
    var dataText = datasetText(element);
    var combined = [label, href, dataText, element.className || ""].join(" ");
    var host = url ? url.hostname.toLowerCase() : "";
    var isOutbound = Boolean(url && host && host !== window.location.hostname.toLowerCase());
    var type = classifyInteraction(combined, url, host);
    return {
      type: type,
      element: {
        role: clean(element.tagName || "element", 80).toLowerCase(),
        label: label,
        href: href ? clean(decorateUrl(href), 1024) : "",
        outbound: isOutbound,
        booking: /booking|book|appointment|consult|checkout|pay|stripe|slot|time/i.test(type + " " + combined),
        dataset: clean(dataText, 500)
      },
      intent: intentFromText(combined, window.location.pathname)
    };
  }

  function trackSearch(query) {
    query = clean(query, 160);
    if (!query || /@|\d{5,}/.test(query)) return;
    track("search", {
      intent: Object.assign(intentFromText(query, window.location.pathname), { search_query: query })
    });
  }

  function captureSearchFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      var query = params.get("q") || params.get("s") || params.get("search") || params.get("query");
      if (query) trackSearch(query);
    } catch (e) {}
  }

  function engagementPayload(finalEvent) {
    return {
      engagement: {
        duration_ms: Math.max(0, Date.now() - state.startedAt),
        max_scroll_percent: state.maxScroll,
        click_count: state.clickCount,
        final: Boolean(finalEvent)
      }
    };
  }

  function sendEngagement(finalEvent) {
    if (state.engagementSent && !finalEvent) return;
    state.engagementSent = true;
    track("engagement_summary", engagementPayload(finalEvent), Boolean(finalEvent));
  }

  function recordFriction(event, element, payload) {
    try {
      var now = Date.now();
      var x = Number(event.clientX || 0);
      var y = Number(event.clientY || 0);
      state.clickBurst = state.clickBurst.filter(function (item) {
        return now - item.t < 1500 && Math.abs(item.x - x) < 44 && Math.abs(item.y - y) < 44;
      });
      state.clickBurst.push({ x: x, y: y, t: now });
      if (state.clickBurst.length >= 3) {
        trackOnce("rage_click", {
          element: payload && payload.element ? payload.element : { role: "unknown", label: elementLabel(element) },
          intent: payload && payload.intent ? payload.intent : intentFromText(elementLabel(element), window.location.pathname),
          engagement: { click_x: x, click_y: y, click_count_window: state.clickBurst.length, window_ms: 1500 }
        }, true);
      }
    } catch (e) {}
  }

  function deadClickElement(target) {
    if (!target || !target.closest) return null;
    return target.closest([
      "[class*='card']",
      "[class*='tile']",
      "[class*='chip']",
      "[class*='pill']",
      "[class*='review']",
      "[class*='testimonial']",
      "[class*='practitioner']",
      "[class*='doctor']",
      "[class*='nurse']",
      "[class*='treatment']",
      "[class*='service']",
      "section",
      "article",
      "img"
    ].join(", "));
  }

  function trackDeadClick(event, target) {
    var node = deadClickElement(target);
    if (!node) return;
    var label = elementLabel(node);
    if (!label) return;
    var startKey = pageKey();
    window.setTimeout(function () {
      if (pageKey() !== startKey) return;
      trackOnce("dead_click", {
        element: { role: clean(node.tagName || "content", 80).toLowerCase(), label: label },
        intent: intentFromText(label, window.location.pathname),
        engagement: { click_x: Number(event.clientX || 0), click_y: Number(event.clientY || 0) }
      });
    }, 900);
  }

  function sectionIdentity(element) {
    if (!element || !element.getAttribute) return "";
    return clean(
      element.getAttribute("data-section")
        || element.getAttribute("data-drsknn-uni-section")
        || element.getAttribute("data-practitioner-id")
        || element.getAttribute("data-treatment-id")
        || element.getAttribute("id")
        || elementLabel(element)
        || element.className
        || "",
      180
    );
  }

  function sectionEventType(element, label) {
    var text = clean([label, element && element.className || "", datasetText(element)].join(" "), 500);
    if (/review|testimonial|rating|stars|result|case study/i.test(text)) return "review_engagement";
    if (/practitioner|doctor|nurse|clinician|therapist|team/i.test(text)) return "viewed_practitioner";
    if (/treatment|service|condition|concern|hydrafacial|botox|filler|laser|acne|pigment|peel|universkin/i.test(text)) return "viewed_treatment";
    return "section_view";
  }

  function observeContent(root) {
    try {
      if (!("IntersectionObserver" in window)) return;
      if (!state.sectionObserver) {
        state.sectionObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.55) return;
            var node = entry.target;
            var identity = sectionIdentity(node);
            if (!identity || state.viewedSections[identity]) return;
            state.viewedSections[identity] = true;
            var label = elementLabel(node) || identity;
            var eventType = sectionEventType(node, label);
            trackOnce(eventType, {
              element: { role: clean(node.tagName || "section", 80).toLowerCase(), label: clean(label, 220) },
              intent: intentFromText(label, window.location.pathname),
              engagement: { visible_ratio: Math.round(entry.intersectionRatio * 100), action: "section_visible" }
            });
          });
        }, { threshold: [0.55, 0.75] });
      }
      var scope = root && root.querySelectorAll ? root : document;
      var selector = [
        "section",
        "article",
        "[data-section]",
        "[data-drsknn-uni-section]",
        "[data-practitioner]",
        "[data-practitioner-id]",
        "[data-treatment]",
        "[data-treatment-id]",
        "[data-service]",
        "[class*='review']",
        "[class*='testimonial']",
        "[class*='practitioner']",
        "[class*='doctor']",
        "[class*='nurse']",
        "[class*='treatment-card']",
        "[class*='service-card']"
      ].join(", ");
      scope.querySelectorAll(selector).forEach(function (node) {
        var identity = sectionIdentity(node);
        if (identity && !state.viewedSections[identity]) state.sectionObserver.observe(node);
      });
    } catch (e) {}
  }

  function trackScrollMilestones() {
    [25, 50, 75, 90].forEach(function (milestone) {
      if (state.maxScroll >= milestone && !state.scrollMilestones[milestone]) {
        state.scrollMilestones[milestone] = true;
        trackOnce("scroll_milestone", {
          engagement: { scroll_percent: milestone, max_scroll_percent: state.maxScroll }
        });
      }
    });
  }

  function syncShopifyCartAttributes() {
    if (!config.cartAttributes || !isShopifyStorefrontHost(window.location.hostname)) return;
    if (!marketingAllowed()) return;
    var attribution = readStored();
    var attrs = {
      "attributes[drsknn_visitor_id]": visitorId(),
      "attributes[drsknn_session_id]": sessionId(),
      "attributes[drsknn_landing_url]": clean(attribution.landing_url || window.location.href, 500)
    };
    ATTR_KEYS.forEach(function (key) {
      if (attribution[key]) attrs["attributes[drsknn_" + key + "]"] = attribution[key];
    });
    try {
      var body = new URLSearchParams();
      Object.keys(attrs).forEach(function (key) {
        body.set(key, attrs[key]);
      });
      window.fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
        body: body.toString()
      }).catch(function () {});
    } catch (e) {}
  }

  window.DRSKNN_ATTRIBUTION = {
    get: readStored,
    capture: captureAttribution,
    googleMeasurementContext: googleMeasurementContext,
    decorateUrl: decorateUrl,
    decorateAll: decorateAll,
    normalizeBookingLinks: normalizeBookingLinks,
    track: track
  };
  try {
    captureAttribution();
    visitorId();
    sessionId();
  } catch (e) {
    window.DRSKNN_ATTRIBUTION.initError = clean(e && e.message || e, 255);
  }

  function initializePage() {
    privateBrowserOutbox();
    decorateAll(document);
    if (isIncomingTikTok(incomingParams())) {
      window.setTimeout(function () { decorateAll(document); }, 500);
    }
    observeContent(document);
    state.lastPageKey = pageKey();
    var initialIntent = intentFromText(document.title, window.location.pathname + " " + window.location.search + " " + window.location.hash);
    track(pageEventType(initialIntent), { intent: initialIntent });
    captureSearchFromUrl();
    syncShopifyCartAttributes();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializePage);
  } else {
    initializePage();
  }

  document.addEventListener("click", function (event) {
    if (!isIncomingTikTok(incomingParams())) return;
    var target = event.target && event.target.closest ? event.target.closest("a[href]") : null;
    if (target) decorateElement(target, "href");
  }, true);

  window.addEventListener("drsknn:consent-ready", function () {
    captureAttribution();
    decorateAll(document);
    if (window.DRSKNN_CONSENT_STATE && (window.DRSKNN_CONSENT_STATE.analytics || window.DRSKNN_CONSENT_STATE.marketing)) {
      state.lastPageKey = "";
      trackVirtualPage("consent_update");
    }
    syncShopifyCartAttributes();
  });

  document.addEventListener("click", function (event) {
    var element = importantElement(event.target);
    if (!element) {
      trackDeadClick(event, event.target);
      return;
    }
    if (handleLegacyBookingClick(event, element)) return;
    decorateElement(element, "href");
    state.clickCount += 1;
    var measurementApi = window.DRSKNN_GOOGLE_MEASUREMENT;
    if (measurementApi && typeof measurementApi.refreshIdentity === "function") measurementApi.refreshIdentity(false);
    var payload = clickPayload(element);
    recordFriction(event, element, payload);
    trackOnce(payload.type, { element: payload.element, intent: payload.intent });
    if (payload.element && payload.element.booking) {
      trackOnce("started_booking", { element: payload.element, intent: payload.intent });
      syncShopifyCartAttributes();
    }
    window.setTimeout(function () { trackVirtualPage("post_click"); }, 250);
  }, true);

  document.addEventListener("submit", function (event) {
    try {
      var form = event.target;
      var input = form && form.querySelector ? form.querySelector("input[type='search'], input[name='q'], input[name='s'], input[name='search'], input[name='query']") : null;
      if (input && input.value) {
        trackSearch(input.value);
      } else if (form) {
        trackOnce("form_submit", {
          element: {
            role: "form",
            label: clean(form.getAttribute("aria-label") || form.getAttribute("name") || form.getAttribute("id") || "website form", 160)
          },
          intent: intentFromText(elementLabel(form), window.location.pathname)
        }, true);
      }
    } catch (e) {}
  }, true);

  document.addEventListener("change", function (event) {
    try {
      var target = event.target;
      if (!target || !isSafeIntentField(target)) return;
      var value = clean(target.value || target.options && target.options[target.selectedIndex] && target.options[target.selectedIndex].text || "", 160);
      if (!value) return;
      var field = safeFieldName(target);
      var intent = intentFromText(field + " " + value, window.location.pathname);
      var eventType = /slot|time|date/i.test(field) ? "selected_timeslot" : /search|query|filter/i.test(field) ? "search" : "viewed_treatment";
      var extra = {
        element: { role: clean(target.tagName || "field", 80).toLowerCase(), label: clean(field + ": " + value, 180) },
        intent: Object.assign(intent, /search|query|filter/i.test(field) ? { search_query: value } : {})
      };
      trackOnce(eventType, extra);
    } catch (e) {}
  }, true);

  document.addEventListener("focusin", function (event) {
    try {
      var target = event.target;
      if (!target || !/^(input|select|textarea)$/i.test(target.tagName || "")) return;
      var kind = fieldKind(target);
      trackOnce("form_progress", {
        element: { role: "field", label: kind },
        engagement: { action: "field_focus" }
      });
    } catch (e) {}
  }, true);

  document.addEventListener("input", function (event) {
    try {
      var target = event.target;
      if (!target || !isSafeIntentField(target)) return;
      var field = safeFieldName(target);
      if (!/search|query|filter/i.test(field)) return;
      window.clearTimeout(target.__drsknnSearchTimer);
      target.__drsknnSearchTimer = window.setTimeout(function () {
        trackSearch(target.value);
      }, 800);
    } catch (e) {}
  }, true);

  window.addEventListener("scroll", function () {
    try {
      var doc = document.documentElement;
      var scrollTop = window.pageYOffset || doc.scrollTop || 0;
      var height = Math.max(1, doc.scrollHeight - window.innerHeight);
      state.maxScroll = Math.max(state.maxScroll, Math.min(100, Math.round((scrollTop / height) * 100)));
      trackScrollMilestones();
    } catch (e) {}
  }, { passive: true });

  window.setTimeout(function () {
    sendEngagement(false);
  }, 15000);

  window.addEventListener("pagehide", function () {
    sendEngagement(true);
  });

  try {
    ["pushState", "replaceState"].forEach(function (method) {
      var original = history[method];
      if (typeof original !== "function") return;
      history[method] = function () {
        var result = original.apply(this, arguments);
        window.setTimeout(function () { trackVirtualPage(method); }, 0);
        return result;
      };
    });
    window.addEventListener("popstate", function () { trackVirtualPage("popstate"); });
    window.addEventListener("hashchange", function () { trackVirtualPage("hashchange"); });
  } catch (e) {}

  try {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" && mutation.attributeName === "src") {
          decorateElement(mutation.target, "src");
          return;
        }
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          decorateAll(node);
          observeContent(node);
          if (node.tagName && node.tagName.toLowerCase() === "iframe") decorateElement(node, "src");
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["src"] });
  } catch (e) {}
})();
